import styled from 'styled-components';
import { getTheme, parseTheme } from 'mol-ui';

export const BtnContainer = styled.div`
    display: flex;
    justify-content: center;
    height: 100px;
`;

export const Content = styled.div`
    height: calc(100% - 100px);
    overflow-y: auto;
`;

export const Container = styled.div`
    height: calc(100% - 60px);
`;

export const DropContainer = styled.div`
    align-items: center;
    border: 1px dashed ${ getTheme('primaryLighterColor') };
    border-radius: 10px;
    ${ parseTheme('color', 'primaryLighterColor') }
    display: flex;
    font-size: 12px;
    font-style: italic;
    height: 55px;
    justify-content: center;
    width: 100%;
`;

export const IconContainer = styled.div`
    cursor: pointer;
    height: 100%;
    width: 100%;
`;

export const Layout = styled.div`
    height: 100%;
`;
